import Component from "@base/Component.js";
import t from "@/services/translationService.js";
import { COCKPIT_SECTIONS } from "../cockpitSections.js";

/**
 * Cockpit shell: a left-hand section list beside the active panel.
 *
 * The shell owns nothing but navigation — each section's panel fetches and
 * renders its own data, so sections stay independent of one another and of the
 * public pages. Links are real hrefs (#/cockpit/:id) so a section can be
 * bookmarked, opened in a new tab and reached with the browser's back button.
 *
 * props: { lang, section: SectionDefinition }
 */
export default class CockpitPage extends Component {
  render() {
    const activeId = this.props.section.id;

    const links = COCKPIT_SECTIONS.map((section) => {
      const isActive = section.id === activeId;
      return `
        <a class="cockpit__nav-link${isActive ? " is-active" : ""}"
           href="#/cockpit/${section.id}"
           ${isActive ? 'aria-current="page"' : ""}>
          ${section.icon}
          <span class="cockpit__nav-label">${Component.escape(t.t(section.labelKey))}</span>
        </a>`;
    }).join("");

    return `
      <div class="cockpit">
        <aside class="cockpit__sidebar">
          <div class="cockpit__brand">
            <span class="cockpit__brand-kicker">${Component.escape(t.t("cockpit.kicker"))}</span>
            <h1 class="cockpit__brand-title">${Component.escape(t.t("cockpit.title"))}</h1>
          </div>
          <nav class="cockpit__nav" aria-label="${Component.escape(t.t("cockpit.title"))}">${links}</nav>
        </aside>
        <div class="cockpit__content">
          <div class="cockpit__outlet"></div>
        </div>
      </div>`;
  }

  async onMounted() {
    const { Panel } = this.props.section;
    this.panel = await this.mountChild(Panel, { lang: this.props.lang }, this.$(".cockpit__outlet"));
  }
}
